import React from 'react'

export const Entypo = ({ name }) => (
  name === 'check'
    ? <span style={{color: 'green', marginRight: 5 }}>v</span>
    : <span style={{color: 'red', marginRight: 5 }}>x</span>
)



// WEBPACK FOOTER //
// ./src/@expo/vector-icons.js